(function(){
  var GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_RE = /^\+?[0-9\-\s]{10,18}$/;
  var SUBMIT_THROTTLE_MS = 60000;

  function setErr(form, name, msg){
    var el = form.querySelector('[name="'+name+'"]');
    if(el){ el.setAttribute('aria-invalid','true'); }
    var em = form.querySelector('.b2b-lead-form__err[data-for="'+name+'"]');
    if(em){ em.textContent = msg; em.classList.add('is-on'); }
  }
  function clearErrs(form){
    form.querySelectorAll('[aria-invalid="true"]').forEach(function(el){ el.removeAttribute('aria-invalid'); });
    form.querySelectorAll('.b2b-lead-form__err').forEach(function(el){ el.textContent=''; el.classList.remove('is-on'); });
    var s = form.querySelector('.b2b-lead-form__server-err');
    if(s){ s.textContent=''; s.classList.remove('is-on'); s.hidden = true; }
  }
  function showServerErr(form, msg){
    var s = form.querySelector('.b2b-lead-form__server-err');
    if(s){ s.textContent = msg; s.classList.add('is-on'); s.hidden = false; }
  }

  function init(form){
    if(form.__b2bInit) return;
    form.__b2bInit = true;
    var startedField = form.querySelector('[name="_form_started_at"]');
    var firstFocusHandler = function(){
      if(startedField && startedField.value === '0'){ startedField.value = String(Date.now()); }
      form.removeEventListener('focusin', firstFocusHandler);
      form.removeEventListener('input', firstFocusHandler);
    };
    form.addEventListener('focusin', firstFocusHandler);
    form.addEventListener('input', firstFocusHandler);

    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      clearErrs(form);

      var fd = new FormData(form);
      var get = function(k){ var v = fd.get(k); return v == null ? '' : String(v).trim(); };

      var company = get('company_name');
      var name = get('contact_name');
      var email = get('contact_email');
      var phone = get('contact_phone');
      var gstin = get('gstin');
      var quantity = get('quantity');
      var budget = get('budget');
      var consent = !!form.querySelector('[name="consent_check"]:checked');

      var ok = true;
      if(!company){ setErr(form,'company_name','Required'); ok=false; }
      if(!name){ setErr(form,'contact_name','Required'); ok=false; }
      if(!email && !phone){
        setErr(form,'contact_email','Provide email or phone');
        setErr(form,'contact_phone','Provide email or phone');
        ok=false;
      }
      if(email && !EMAIL_RE.test(email)){ setErr(form,'contact_email','Invalid email'); ok=false; }
      if(phone && !PHONE_RE.test(phone)){ setErr(form,'contact_phone','Invalid phone'); ok=false; }
      if(gstin && !GSTIN_RE.test(gstin.toUpperCase())){ setErr(form,'gstin','Invalid GSTIN format'); ok=false; }
      if(quantity){ var q = Number(quantity); if(!isFinite(q) || q < 1 || q > 100000){ setErr(form,'quantity','1 to 100000'); ok=false; } }
      if(budget){ var b = Number(budget); if(!isFinite(b) || b < 0 || b > 10000000){ setErr(form,'budget','0 to 1 crore'); ok=false; } }
      if(!consent){ showServerErr(form,'Please accept the consent checkbox to submit.'); ok=false; }

      if(!ok) return;

      try {
        var last = Number(localStorage.getItem('b2b_form_last_submit') || 0);
        if(Date.now() - last < SUBMIT_THROTTLE_MS){
          showServerErr(form,'You just submitted this form a moment ago — please wait a minute before submitting again.');
          return;
        }
      } catch(e){}

      var payload = {
        company_name: company,
        contact_name: name,
        contact_email: email,
        contact_phone: phone,
        gstin: gstin ? gstin.toUpperCase() : '',
        source: 'b2b_form_v1',
        brand_id: get('brand_id'),
        city: get('city'),
        requirement_type: get('requirement_type'),
        product_interest: get('product_interest'),
        quantity: quantity ? Number(quantity) : null,
        budget_inr: budget ? Number(budget) : null,
        decision_timeline: get('timeline'),
        message: get('message'),
        _source_page: get('_source_page'),
        _form_version: get('_form_version'),
        _form_started_at: Number(get('_form_started_at')) || Date.now(),
        _hp_company_url: get('_hp_company_url')
      };

      var btn = form.querySelector('.b2b-lead-form__submit');
      var origText = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Sending...'; }

      var url = form.getAttribute('data-webhook') || 'https://webhooks.gs-ops.in/webhook/b2b-lead-intake';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit'
      })
      .then(function(r){ return r.json().then(function(j){ return { status: r.status, body: j }; }).catch(function(){ return { status: r.status, body: {} }; }); })
      .then(function(res){
        if(res.status >= 200 && res.status < 300){
          try { localStorage.setItem('b2b_form_last_submit', String(Date.now())); } catch(e){}
          var wrap = form.closest('.b2b-lead-form');
          var success = wrap.querySelector('.b2b-lead-form__success');
          form.hidden = true;
          if(success){ success.hidden = false; success.scrollIntoView({behavior:'smooth', block:'start'}); }
        } else if(res.status === 429){
          showServerErr(form,'Too many submissions from your network. Please try again later.');
        } else if(res.status === 401){
          showServerErr(form,'Submission rejected. Please try refreshing the page and try again.');
        } else if(res.status >= 400 && res.status < 500){
          var msg = (res.body && res.body.error) ? ('Could not send: ' + res.body.error) : 'Could not send your enquiry. Please check the form and try again.';
          showServerErr(form, msg);
        } else {
          showFallback(form);
        }
      })
      .catch(function(){ showFallback(form); })
      .finally(function(){
        if(btn){ btn.disabled = false; btn.textContent = origText; }
      });
    });
  }

  function showFallback(form){
    var em = form.getAttribute('data-fallback-email') || '';
    var ph = form.getAttribute('data-fallback-phone') || '';
    var parts = ['Sorry, we could not send your enquiry right now.'];
    if(ph){ parts.push('Please call us at ' + ph + '.'); }
    if(em){ parts.push('Or email ' + em + '.'); }
    showServerErr(form, parts.join(' '));
  }

  function bootAll(){
    document.querySelectorAll('form.b2b-lead-form__form').forEach(init);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
})();
